import { render, staticRenderFns } from "./BranchesAddNewBranch.vue?vue&type=template&id=15ebe1cc&"
import script from "./BranchesAddNewBranch.vue?vue&type=script&lang=js&"
export * from "./BranchesAddNewBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports